export default "__VITE_ASSET__DSJejskO__"